import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import { useCombinedRefs } from '@toss/react';
import { forwardRef } from 'react';
import { useImpressionRef } from './useImpressionRef.mjs';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["rootMargin", "areaThreshold", "timeThreshold", "className", "children", "onImpressionStart", "onImpressionEnd", "style"];
var ImpressionArea = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var rootMargin = _ref.rootMargin,
      areaThreshold = _ref.areaThreshold,
      timeThreshold = _ref.timeThreshold,
      className = _ref.className,
      children = _ref.children,
      onImpressionStart = _ref.onImpressionStart,
      onImpressionEnd = _ref.onImpressionEnd,
      style = _ref.style,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var impressionRef = useImpressionRef({
    onImpressionStart: onImpressionStart,
    onImpressionEnd: onImpressionEnd,
    areaThreshold: areaThreshold,
    timeThreshold: timeThreshold,
    rootMargin: rootMargin
  });
  var ref = useCombinedRefs(forwardedRef, impressionRef);
  return /*#__PURE__*/jsx("div", _objectSpread2(_objectSpread2({
    className: className,
    ref: ref,
    style: style
  }, otherProps), {}, {
    children: children
  }));
});

export { ImpressionArea };
